import * as XLSX from "xlsx";
// import xtype from 'xtypejs';
import {getStorage, ref, getBlob, uploadBytes, deleteObject} from "firebase/storage";
import { initializeApp } from "firebase/app";
import bcryptjs from "bcryptjs";
import { saveAs } from "file-saver";
import JSZip from "jszip";

// export const readExcel = (file, url, success, error) => {
//   const reader = new FileReader();
// 	const rABS = !!reader.readAsBinaryString;
// 	reader.onload = (e) => {
// 		const bstr = e.target.result;
// 		const wb = XLSX.read(bstr, {type:rABS ? 'binary' : 'array'});
// 		const wsname = wb.SheetNames[0];
// 		const ws = wb.Sheets[wsname];
// 		const data = XLSX.utils.sheet_to_json(ws);
//     if(data!=null){
//       axios.post(url ,data
//       ,{
//         withCredentials: true,
//         headers:{
//           'Content-Type':'application/json',
//         },
//       }).then(res => {
//         if(res.data != null){
//           success(true);
//         }
//       }).catch(err => {error(err.message);})
//     }
// 		return ;
// 	};
// 	if(rABS) reader.readAsBinaryString(file); else reader.readAsArrayBuffer(file);
// }

const firebaseConfig = {
  apiKey: "AIzaSyAhbtGBl02teB696nnSnIG9R0iyoxzWKqY",
  authDomain: "web-mpq-back.firebaseapp.com",
  projectId: "web-mpq-back",
  storageBucket: "web-mpq-back.appspot.com",
  messagingSenderId: "231373872836",
  appId: "1:231373872836:web:7520cfce46d010da7f7391",
  measurementId: "G-YF7625Z383"
};

const init = initializeApp(firebaseConfig);

const file_name = 'data.json'
const file_admin = 'admin.json'
const file_residue = 'img_residue.json'

// export const readExcel = (setData, setError, file) => {
//   const storage = getStorage(init);
//   getDownloadURL(ref(storage, `files/${file}`)).then((url) => {
//     const xhr = new XMLHttpRequest();
//     xhr.responseType = 'blob';
//     xhr.onload = (event) => {
//       const reader = new FileReader();
//       const rABS = !!reader.readAsBinaryString;
//       reader.onload = (e) => {
//         const bstr = e.target.result;
//         const wb = XLSX.read(bstr, {type:rABS ? 'binary' : 'array'});
//         const wsname = wb.SheetNames[0];
//         const ws = wb.Sheets[wsname];
//         const data = XLSX.utils.sheet_to_json(ws);
//         setData(data);
//         return ;
//       };
//       if(rABS) reader.readAsBinaryString(xhr.response); else reader.readAsArrayBuffer(xhr.response);
//     };
//     xhr.open('GET', url);
//     xhr.send();
//   }).catch((error)=> setError(error));
// }

//----------------------------------------------------------------
export const backup = async () => {
  const storage = getStorage(init);
  var blob = await getBlob(ref(storage, file_name))
  var blobText = await blob.text();
  var data = JSON.parse(blobText);
  const wb = XLSX.utils.book_new();
  for (const part in data) {
    var ws
    if (part === "visi" || part === "misi")
      if (part === "visi")
        ws = XLSX.utils.json_to_sheet(data[part].map(item => { return {"visi" : item}}))
      else
        ws = XLSX.utils.json_to_sheet(data[part].map(item => { return {"misi" : item}}))
    else {
      if (part === "activity" || part === "achievement") {
        var dt = [...data[part]]
        for (var i = 0;i < dt.length;i++) {
          var obj = {...dt[i]}
          var kj = 1
          for (var hg of [...obj.images]) {
            obj[`image${kj}`] = hg
            kj+=1
          }
          delete obj.images
          dt[i] = obj
        }
        ws = XLSX.utils.json_to_sheet(dt)
      }
      else ws = XLSX.utils.json_to_sheet(data[part]);
    } 
    wb.SheetNames.push(`${part}_Data`);
    wb.Sheets[`${part}_Data`] = ws;
  }
  await XLSX.writeFile(wb,`backup_data_MPQ_${new Date().toLocaleString("en-US")}.xlsx`,{compression: true});
}

export const readData = async () => {
  const storage = getStorage(init);
  var blob = await getBlob(ref(storage, file_name))
  var blobText = await blob.text();
  var data = JSON.parse(blobText);
  return await data
}

export const readDataAdmin = async () => {
  const storage = getStorage(init);
  var blob = await getBlob(ref(storage, file_admin))
  var blobText = await blob.text();
  var data = JSON.parse(blobText);
  return await data
}

export const readDataResidue = async () => {
  const storage = getStorage(init);
  var blob = await getBlob(ref(storage, file_residue))
  var blobText = await blob.text();
  var data = JSON.parse(blobText);
  return await data
}

//----------------------------------------------------------------
export const writeData = async (data) => {
  const storage = getStorage(init);
  var dt = await cleanData(data)
  const str = JSON.stringify(dt);
  const bytes = new TextEncoder().encode(str);
  const blob = new Blob([bytes], {
      type: "application/json;charset=utf-8"
  });
  await uploadBytes(ref(storage, file_name), blob)
  return 'Uploaded data success !!!'
}

//----------------------------------------------------------------
export const writeDataAdmin = async (data) => {
  const storage = getStorage(init);
  var dt = await cleanDataAdmin(data)
  const str = JSON.stringify(dt);
  const bytes = new TextEncoder().encode(str);
  const blob = new Blob([bytes], {
      type: "application/json;charset=utf-8"
  });
  await uploadBytes(ref(storage, file_admin), blob)
  return 'Uploaded data success !!!';
}

//----------------------------------------------------------------
async function cleanData(data) {
  var length = 0
  for (const dt in data) {
    if (length > 15000) throw new Error('limit data exceded, call your master admin to make backup an old data, then clean up it')
    length += data[dt].length
  }
  return data
}

//----------------------------------------------------------------
async function cleanDataAdmin(data) {
  var dtd = []
  for (var dt of data) {
    var cleanedData = { ...dt };
    if (cleanedData.hasOwnProperty('_password')) {
      delete cleanedData._password
    }
    dtd.push(cleanedData)
  }
  return dtd
}

// ----------------------------------------------------------------
export async function cleanOldData(data,oldImg,scale=.5) {
  if (scale > 1) {
    throw new Error('scale cannot more than 1')
  }
  var dtd = {...data}
  var ac = data['activity'].length
  var al = data['alumni'].length
  if (scale < 1.0) {
    var gh = dtd['activity'].slice(Math.round(ac*scale)).flatMap(a => a.images)
    var jk = dtd['alumni'].slice(Math.round(al*scale)).map(a => a.image)
    await writeDataResidue([...oldImg,...gh,...jk])
    dtd['activity'] = dtd['activity'].slice(0,Math.round(ac*scale))
    dtd['alumni'] = dtd['alumni'].slice(0,Math.round(al*scale))
    await writeData(dtd)
  } else {
    var gh = dtd['activity'].flatMap(a => a.images)
    var jk = dtd['alumni'].map(a => a.image)
    await writeDataResidue([...oldImg,...gh,...jk])
    dtd['activity'] = []
    dtd['alumni'] = []
    await writeData(dtd)
  }
  return dtd
}

//----------------------------------------------------------------
const writeDataResidue = async (data) => {
  const storage = getStorage(init);
  const str = JSON.stringify(data);
  const bytes = new TextEncoder().encode(str);
  const blob = new Blob([bytes], {
      type: "application/json;charset=utf-8"
  });
  await uploadBytes(ref(storage, file_residue), blob)
}

//----------------------------------------------------------------
export async function cleanImgAndBackup(names) {
  const storage = getStorage(init);
  var files = []
  for (var name of names) {
    var blob = await getBlob(ref(storage,`/images/${name}`))
    files.push(blob)
    await deleteObject(ref(storage,`/images/${name}`))
  }
  var zip = new JSZip()
  for (let i = 0; i < files.length; i++) {
    zip.file(names[i],files[i])
  }
  var data = await zip.generateAsync({type:'blob'})
  await saveAs(data,"gambar.zip")
}

//----------------------------------------------------------------
export const getImage = async (file) => {
  const storage = getStorage(init);
  var blob = await getBlob(ref(storage, `/images/${file}`))
  return new Promise(async (resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = function () {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };

    reader.readAsDataURL(blob);
  });
}

//----------------------------------------------------------------
const uploadImage = async (files=[], names=[], prefix='') => {
  const storage = getStorage(init);
  var filename = []
  var namebc = [...names]
  for (var i = 0;i < files.length;i++) {
    var snapsot
    if (names[i]) {
      snapsot = await uploadBytes(ref(storage, `/images/${names[i]}`), files[i])
      namebc = namebc.filter(bd => bd !== names[i])
    }
    else
      snapsot = await uploadBytes(ref(storage, `/images/${prefix+uuidv4()+new Date().toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' })}.jpg`), files[i])
    filename.push(snapsot.metadata.name)
  }
  if (namebc.length > 0) {
    filename = [...filename,...namebc]
  }
  return filename
}

// export const getFile = async(file) => {
//   const storage = getStorage(init);
//   return await getDownloadURL(ref(storage, `/files/${file}`))
// }

// export const uploadFile = (files=[], setError, setResp) => {
//   const storage = getStorage(init);
//   for (const file in files) {
//     uploadBytes(ref(storage, `/files/${file.name}`), file).then(() => {
//       setResp('Uploaded file success !!!');
//       return ;
//     }).catch((error)=> setError(error));
//   }
// }

// const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
//----------------------------------------------------------------
export async function login(data=[],name,password) {
  var dty = data.find((val) => val.name === name)
  if (dty) {
    if (bcryptjs.compareSync(password, dty.password))
      if (dty.type === "dev") {
        return Page.DEVC
      }
      else {
        return Page.ADMINC
      }
    else throw new Error("wrong password")
  }
  throw new Error("username does`nt exist")
}

//----------------------------------------------------------------
export async function changePassword(data=[],name,oldPassword,newPassword) {
  var dty = data.findIndex((val) => val.name === name)
  var dtd = [...data]
  if (dty !== -1) {
    if (bcryptjs.compareSync(oldPassword, data[dty].password)) {
      var dtk = data[dty]
      dtk.password = bcryptjs.hashSync(newPassword,12)
      dtd[dty] = dtk
    } else throw new Error("wrong password")
  } else throw new Error("username does`nt exist")
  await writeDataAdmin(dtd)
  return dtd
}

//----------------------------------------------------------------
export function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

//----------------------------------------------------------------
async function resizeMe(img,callback) {
  var canvas = document.createElement('canvas');

  var width = img.width;
  var height = img.height;

  // if (width > height) {
  //   if (width > 768) {
  //     height = Math.round(height *= 768 / width);
  //     width = 768;
  //   }
  // } else {
  //   if (height > 480) {
  //     width = Math.round(width *= 480 / height);
  //     height = 480;
  //   }
  // }

  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);

  // return canvas.toDataURL("image/jpeg",0.8);
  return canvas.toBlob(blob => {callback(blob)},"image/jpeg",.9)
}

//----------------------------------------------------------------
export const saveImage = async (arr,imgArr) => {
  var arrdt = []
  for (var i = 0; i < arr.length; i++) {
    var dt = { ...arr[i] }

    if(i < imgArr.length) {
      if (dt.hasOwnProperty("image")) {
        var img = await uploadImage([imgArr[i]],(dt.image)?[dt.image]:[],'stafforalumni')
        dt.image = img[0]
      } 
      if (dt.hasOwnProperty("images")) {
        var imgs = await uploadImage(imgArr[i],(dt.images.length > 0)?[...dt.images]:[],'activity')
        dt.images = [...imgs]
      }
    }

    arrdt.push(dt)
  }

  return arrdt
}

export const Page = {
  HOME:'home',
  DEV:'dev',
  ADMIN:'admin',
  DEVC:'devcontainer',
  ADMINC:'admincontainer',
  TEAM:'team'
}